export const cancelReasonOptions = {
    rider_unreachable: "Rider not reachable or not at pickup location",
    pickup_incorrect_or_far: "Incorrect or far pickup location",
    destination_too_far: "Destination too far or outside service area",
    drop_changed: "Rider changed drop location after booking",
    payment_issue: "Payment mode not acceptable",
    vehicle_issue: "Vehicle issue or low fuel",
    personal_emergency: "Personal emergency or health reason",
    traffic_or_weather: "Poor traffic or weather conditions",
};

export const cancelReasons = (cancelReason) => {
    return cancelReasonOptions[cancelReason] || cancelReason;
};